import { useEffect } from 'react';

const STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "DaySpa",
  "name": "Sereno Spa",
  "alternateName": "Sereno Day Spa",
  "description": "Luxury spa treatments and wellness services in Livingston Manor, NY. Experience ultimate relaxation with our facials, hair removal, lashes & brows, massage, and wellness treatments.",
  "url": "https://serenodayspa.com",
  "telephone": "845-439-1084",
  "email": "jamiewaichman@serenodayspa.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "43 Main St #1A",
    "addressLocality": "Livingston Manor",
    "addressRegion": "NY",
    "postalCode": "12758",
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "41.9023",
    "longitude": "-74.8287"
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "09:00",
      "closes": "18:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Saturday"],
      "opens": "10:00",
      "closes": "17:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Sunday"],
      "opens": "10:00",
      "closes": "15:00"
    }
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Spa Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Facials",
          "description": "Professional facial treatments including signature facials, dermaplaning, microdermabrasion, and BioRePeel"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Hair Removal",
          "description": "Professional hair removal services using sugaring and traditional waxing techniques"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Lashes & Brows",
          "description": "Eyebrow waxing and lash lift & tint services"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Massage",
          "description": "Therapeutic massage including Aromatherapy, Swedish, Prenatal, and Customized options"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Lifestyle Wellness",
          "description": "LED light therapy and wellness treatments for overall rejuvenation"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Chemical Peels",
          "description": "Professional chemical peels, deep sea peels, and BioRePeel for skin renewal"
        }
      }
    ]
  },
  "image": [
    "https://customer-assets.emergentagent.com/job_fe1c91c4-a8c1-49c7-93bd-706bc696132c/artifacts/yn6qr8bb_IMG_6344.JPG"
  ],
  "sameAs": [
    "https://www.facebook.com/share/17CSC2mU2R/?mibextid=wwXIfr",
    "https://www.instagram.com/sereno_day_spa/"
  ],
  "founder": {
    "@type": "Person",
    "name": "Jamie Waichman",
    "jobTitle": "Esthetician/RN"
  },
  "employee": [
    {
      "@type": "Person",
      "name": "Jamie Waichman",
      "jobTitle": "Esthetician/RN"
    },
    {
      "@type": "Person",
      "name": "Yoki Mota",
      "jobTitle": "Esthetician"
    },
    {
      "@type": "Person",
      "name": "Anthony Schelin",
      "jobTitle": "Massage Therapist"
    }
  ]
};

const StructuredData = () => {
  useEffect(() => {
    const id = 'sereno-structured-data';
    let script = document.getElementById(id);
    if (!script) {
      script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(STRUCTURED_DATA);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  return null;
};

export default StructuredData;
